import { useSearchParams } from "next/navigation"

import { usePageContext } from "@/modules/jobSearch/components/PageContext/PageContextProvider"
import { parsedUrlQueryToURLSearchParams } from "@/modules/routing/utils"

import { usePrefilteredJobSearch } from "./usePrefilteredJobSearch"

export const usePrefilteredJobSearchParams = (): URLSearchParams => {
  const searchParams = useSearchParams()
  const isPrefilteredJobSearch = usePrefilteredJobSearch()
  const { prefilteredSearchParams: filteredQuery } = usePageContext()

  if (isPrefilteredJobSearch) {
    const prefilteredSearchParams = new URLSearchParams(searchParams)

    return parsedUrlQueryToURLSearchParams(filteredQuery, prefilteredSearchParams)
  }

  return searchParams
}
